// `useRoute()`-style accessor for components.
//
// The Router writes the matched route's params into a module-scoped
// rune after every navigation. Components read `route.params` etc.
// and re-render reactively when the underlying values change.
//
// Why a module-scoped rune rather than props? Components deep in the
// tree often want the current route info without prop-drilling
// through every layout. The legacy Leptos SPA used Leptos's
// `use_params()` for the same reason; this is the Svelte equivalent.

import { history } from "./history.svelte";

class RouteStore {
  // Mutated by Router on every match. Empty when no route matches.
  params = $state<Record<string, string>>({});

  get pathname(): string {
    return history.pathname;
  }
  get search(): string {
    return history.search;
  }
  get query(): URLSearchParams {
    return history.query;
  }
  get hash(): string {
    return history.hash;
  }
}

export const route = new RouteStore();

/** Router-internal: update the current params. Components should
 *  never call this. */
export function _setParams(p: Record<string, string>): void {
  route.params = p;
}
